module.exports = __webpack_public_path__ + "img/album18_20.60a5bc39.jpg";